/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BillingWallet } from './BillingWallet';
import {
    BillingWalletFromJSON,
    BillingWalletFromJSONTyped,
    BillingWalletToJSON,
    BillingWalletToJSONTyped,
} from './BillingWallet';

/**
 * 
 * @export
 * @interface UpdateBillingWalletResponse
 */
export interface UpdateBillingWalletResponse {
    /**
     * 
     * @type {BillingWallet}
     * @memberof UpdateBillingWalletResponse
     */
    data: BillingWallet;
}

/**
 * Check if a given object implements the UpdateBillingWalletResponse interface.
 */
export function instanceOfUpdateBillingWalletResponse(value: object): value is UpdateBillingWalletResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateBillingWalletResponseFromJSON(json: any): UpdateBillingWalletResponse {
    return UpdateBillingWalletResponseFromJSONTyped(json, false);
}

export function UpdateBillingWalletResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBillingWalletResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': BillingWalletFromJSON(json['data']),
    };
}

  export function UpdateBillingWalletResponseToJSON(json: any): UpdateBillingWalletResponse {
      return UpdateBillingWalletResponseToJSONTyped(json, false);
  }

  export function UpdateBillingWalletResponseToJSONTyped(value?: UpdateBillingWalletResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BillingWalletToJSON(value['data']),
    };
}

